import React, { memo } from "react";
import { View } from "react-native";
import { isCLApp } from "../../config";
import AppText from "../AppText";
import RenderCMSEntity from "./FetchCMSEntity";

const BannersList = memo((props) => {
  const { list_items = [], cl_title, cx_title, trackEvent, loading } = props;

  const titleText = isCLApp ? cl_title : cx_title;

  return (
    <View style={styles.container}>
      {typeof titleText === "string" && titleText.trim().length ? (
        <AppText bold fontType="head2" style={styles.listHeader}>
          {titleText}
        </AppText>
      ) : (
        <></>
      )}
      {Array.isArray(list_items) && list_items.length !== 0
        ? list_items.map((item) => (
            <RenderCMSEntity
              trackEvent={trackEvent}
              id={item.cms_item_id}
              key={item.cms_item_id}
              from_banner_list
              {...item}
            />
          ))
        : null}
    </View>
  );
});

const styles = {
  container: {
    flex: 1,
    backgroundColor: "#F7F7F7",
    // padding: 15
  },
  listHeader: {
    paddingHorizontal: 15,
    paddingTop: 25,
    paddingBottom: 10,
  },
};

export default BannersList;
